<div *ngIf="!loader" class="product-card-wrapper">
    <!-- Tarjeta de producto - versión mejorada -->
    <div class="product-card">
        <!-- Sección de imagen -->
        <div class="img-wrapper">
            <!-- Etiqueta de descuento -->
            <div class="lable-block" *ngIf="product?.discount && product?.product_promote">
                <span class="discount-badge">-{{ (product?.discount).toFixed(0) }}%</span>
            </div>
            
            <!-- Imagen principal -->
            <div class="front">
                <a [href]="['products'+product?.url_product]">
                    <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                        [lazyLoad]="ImageSrc ? ImageSrc : product.images[0].src"
                        class="img-fluid lazy-loading product-main-image"
                        alt="{{ product.images[0].alt }}"/>
                </a>
            </div>
            
            <!-- Imagen hover -->
            <div class="back" *ngIf="onHowerChangeImage">
                <a [href]="['products'+product?.url_product]">
                    <img [src]="ImageSrc ? ImageSrc : product.images[1].src" 
                        class="img-fluid lazy-loading product-hover-image" 
                        alt="{{ product.images[1].alt }}">
                </a>
            </div>
            
            <!-- Miniaturas -->
            <ul class="product-thumb-list" *ngIf="thumbnail">
                <li class="grid_thumb_img" [class.active]="ImageSrc == image.src" *ngFor="let image of product.images">
                    <a href="javascript:void(0)" (mouseover)="ChangeVariantsImage(image.src)">
                        <img [lazyLoad]="image.src" class="thumbnail-img">
                    </a>
                </li>
            </ul>
            
            <!-- Acciones rápidas -->
            <div class="quick-actions">
                <a href="javascript:void(0)" title="Quick View" (click)="QuickView.openModal()" class="quick-action-btn">
                    <i class="ti-search"></i>
                </a>
                <a href="javascript:void(0)" title="Add to Wishlist" (click)="addToWishlist(product)" class="quick-action-btn">
                    <i class="ti-heart"></i>
                </a>
            </div>
        </div>
        
        <!-- Sección de detalles -->
        <div class="product-detail">
            <!-- Título y descripción -->
            <a [href]="['products'+product?.url_product]" class="product-title-link">
                <h6 class="product-title">{{ product?.title | titlecase }}</h6>
            </a>
            
            <p class="product-description">{{ product?.description }}</p>
            
            <!-- Medidas técnicas -->
            <div class="technical-specs" *ngIf="product?.diametro_interno > 0 || product?.diametro_externo > 0 || product?.alto > 0">
                <span class="spec-badge">DE: {{ product?.diametro_externo }}</span>
                <span class="spec-badge">DI: {{ product?.diametro_interno }}</span>
                <span class="spec-badge">H: {{ product?.alto }}</span>
            </div>
            
            <!-- Precio -->
            <div class="price-section">
                <h4 class="current-price">
                    {{ product?.price * currency?.price | discount:product | currency:currency?.currency:'symbol' }}
                </h4>
                <del *ngIf="product?.discount" class="original-price">
                    {{ product?.price * currency?.price | currency:currency?.currency:'symbol' }}
                </del>
                <div *ngIf="product?.discount" class="save-amount">
                    Ahorras {{ (product?.price * currency?.price * product?.discount / 100) | currency:currency?.currency:'symbol' }}
                </div>
            </div>
            
            <!-- Stock -->
            <div class="stock-info">
                <div class="stock-label" [class.in-stock]="product?.stock > 0" [class.out-of-stock]="product?.stock <= 0">
                    {{ product?.stock > 0 ? 'En stock: ' + product?.stock : 'Agotado' }}
                </div>
                <div *ngIf="product?.stock > 0 && product?.stock <= 5" class="low-stock-warning">
                    ¡Últimas unidades!
                </div>
            </div>
            
            <!-- Botón de compra principal -->
            <div class="add-to-cart-section">
                <!-- <button class="btn btn-add-to-cart" 
                        (click)="cartModal ? CartModal.openModal(product) : addToCart(product)"
                        [disabled]="product?.stock <= 0">
                    <i class="ti-shopping-cart me-2"></i>
                    {{ product?.stock > 0 ? 'Añadir al carrito' : 'Agotado' }}
                </button> -->
                <a href="javascript:void(0)" class="buy-now-btn" (click)="addToCart(product)"
                   *ngIf="product?.stock > 0">Add to cart</a>
            </div>
        </div>
    </div>
</div>

<!-- Loader -->
<app-skeleton-product-box *ngIf="loader"></app-skeleton-product-box>

<!-- Modales -->
<app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
<app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>